import { render, staticRenderFns } from "./CreateFeesPage.vue?vue&type=template&id=4b43451d&scoped=true&"
import script from "./CreateFeesPage.vue?vue&type=script&lang=js&"
export * from "./CreateFeesPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateFeesPage.vue?vue&type=style&index=0&id=4b43451d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b43451d",
  null
  
)

export default component.exports